// ============================================================================
// hvsin UI Registry Contracts
//
// 本包仅包含类型定义和常量，不含实现。
// ui-registry-mod、client-runtime-mod 以及业务 Mod 通过此包获取类型信息，
// 通过 hvsin 依赖注入机制获取实际 Service 实例。
// ============================================================================
// ----------------------------------------------------------------------------
// 3. 路由适配器接口
// ----------------------------------------------------------------------------
/** 路由器类型枚举 */
export var RouterType;
(function (RouterType) {
    RouterType["REACT_ROUTER"] = "react-router";
    RouterType["WECHAT_MINI_PROGRAM"] = "wechat-mini-program";
    RouterType["CUSTOM"] = "custom";
})(RouterType || (RouterType = {}));
/** 路由适配器接口标签 */
export const ROUTER_ADAPTER_INTERFACE_TAG = 'IRouterAdapter';
// ----------------------------------------------------------------------------
// 5. 接口标签常量
// ----------------------------------------------------------------------------
/** 页面路由注册服务接口标签 */
export const PAGE_ROUTE_REGISTRY_INTERFACE_TAG = 'IPageRouteRegistryService';
/** 全局状态注册服务接口标签 */
export const GLOBAL_STATE_REGISTRY_INTERFACE_TAG = 'IGlobalStateRegistryService';
/** 组件注册服务接口标签 */
export const COMPONENT_REGISTRY_INTERFACE_TAG = 'IComponentRegistryService';
/** Hooks 注册服务接口标签 */
export const HOOKS_REGISTRY_INTERFACE_TAG = 'IHooksRegistryService';
/** 业务服务注册服务接口标签 */
export const CLIENT_SERVICE_REGISTRY_INTERFACE_TAG = 'IClientServiceRegistryService';
// ----------------------------------------------------------------------------
// 6. 常量数组（便于遍历和校验）
// ----------------------------------------------------------------------------
/** 所有 UI Registry 接口标签常量 */
export const UI_REGISTRY_INTERFACE_TAGS = [
    PAGE_ROUTE_REGISTRY_INTERFACE_TAG,
    GLOBAL_STATE_REGISTRY_INTERFACE_TAG,
    COMPONENT_REGISTRY_INTERFACE_TAG,
    HOOKS_REGISTRY_INTERFACE_TAG,
    CLIENT_SERVICE_REGISTRY_INTERFACE_TAG,
];
//# sourceMappingURL=index.js.map